import { Component } from 'vue-property-decorator'

import { Breadcrumb } from '@/interfaces/breadcrumbs'
import QuotesList from '@/modules/Quote/scripts/quotes-list'

@Component({})
export default class QuotesListFromDashboard extends QuotesList {
  async mounted () {
    await this.clearPage()
    this.getList()
  }
}
